// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1JTSN","name":"ConsentHeader_name__oGDV1","birthday":"ConsentHeader_birthday__18yZi","skeleton":"ConsentHeader_skeleton__1lrLG"};